import React from 'react';
import { Modal, SparkModalPortal, Text } from '@spark';
import { noProviderWarningCopy } from './noProviderWarning';

/**
 * Next-time warning for a Generate-with-AI selection (no-labels mode or
 * empty-response handling) when no model provider is configured. "Add
 * credentials" hands off to the caller (navigate to Settings > Model
 * Providers); Cancel stays on the step. Same warning-modal design as
 * UnknownLabelsWarningModal. Without ``onAddCredentials`` (SaaS non-god:
 * the keys are SpecificAI's) only the dismiss button is shown.
 */
const NoProviderWarningModal = ({ open, taskType, onCancel, onAddCredentials }) => {
    if (!open) return null;
    const { title, body } = noProviderWarningCopy(taskType);
    const canAddCredentials = typeof onAddCredentials === 'function';
    return (
        <SparkModalPortal
            open
            onClose={onCancel}
            size="text"
            className="cw-dc-benchmark-modal-portal"
        >
            <Modal
                title={title}
                feedbackType="warning"
                showSubtitle={false}
                showScrollBar={false}
                showOverlay={false}
                fixedHeight={false}
                showMainButton={canAddCredentials}
                primaryLabel="Add credentials"
                tertiaryLabel={canAddCredentials ? 'Cancel' : 'Got it'}
                onPrimaryClick={onAddCredentials}
                onTertiaryClick={onCancel}
                onCloseClick={onCancel}
                className="cw-dc-benchmark-modal"
            >
                <Text variant="base-regular" color="secondary" as="p">
                    {body}
                </Text>
            </Modal>
        </SparkModalPortal>
    );
};

export default NoProviderWarningModal;
